import React from 'react';
import { Typography } from 'antd';

const { Title, Paragraph } = Typography;

/**
 * Renderuje dokument prawny trzymany jako czysty tekst.
 *
 * Konwencja treści: akapity oddzielone pustą linią, a nagłówek sekcji to akapit
 * jednolinijkowy zaczynający się od numeru lub paragrafu („3. Zasady korzystania",
 * „§ 4. Zakres usług"). Dzięki temu ten sam tekst działa w webie i w mobilkach,
 * bez znaczników i bez parsera markdown.
 */
const NAGLOWEK = /^(§\s*)?\d+\.\s+\S/;

function jestNaglowkiem(blok) {
  return NAGLOWEK.test(blok) && !blok.includes('\n') && blok.length < 90;
}

function LegalText({ text }) {
  if (!text) return null;
  return (
    <>
      {text.split('\n\n').map((blok, i) =>
        jestNaglowkiem(blok) ? (
          <Title level={5} key={i}>
            {blok}
          </Title>
        ) : (
          <Paragraph key={i} style={{ whiteSpace: 'pre-line' }}>
            {blok}
          </Paragraph>
        )
      )}
    </>
  );
}

export default LegalText;
